import {PermissionService} from '../../../common/permission.service';

import {
  Component,
  HostListener, inject,
  OnDestroy,
  OnInit,
  ViewContainerRef,
  ViewEncapsulation,
} from '@angular/core';
import {
  PagesEventService,
  NotificationService,
  Utilities,
} from 'src/app/common/index';
import { ActivatedRoute, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LayoutService } from '../services/layout.service';
import { User, UserAuth } from 'src/app/common/user-auth';
import { TimeTrackingViewModel } from '../models/time-tracking.model';
import { Url } from 'src/app/common/index';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  WindowCloseResult,
  WindowService,
} from '@progress/kendo-angular-dialog';
import { NotificationsComponent } from './notifications.component';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { ChatService } from '../../pages/default/chat/services/chat.service';
import { ConfirmDialogService } from '../services/confirm-dialog.component';
import { Observable, of, Subject } from 'rxjs';
import {
  debounceTime,
  distinctUntilChanged,
  filter,
  map,
  switchMap,
  tap,
} from 'rxjs/operators';
import { Page } from '../../pages/default/knowledge/models/libraries.model';
import { menuOptions } from '../models/menu-items';
declare const Pusher: any;

@Component({
  selector: 'app-topbar',
  templateUrl: '../views/topbar.component.html',
  styleUrls: ['../styles/style.css'],
  encapsulation: ViewEncapsulation.None,
})
export class TopbarComponent implements OnInit,OnDestroy {
  private permissionService = inject(PermissionService);
  public usersOnThisPage: {url: string, tabs:number, id:number, user:any}[] = [];
  public headerTitle = '';
  public breadcrumbs = [];
  public onSaving = false;
  userAuth: User = UserAuth.get();
  dialogs = { startTime: false, endTime: false, travelTime: false, travelTimeEnd:false,transportTypeStart:false,transportTypeEnd:false };
  timeTrackingViewModel = new TimeTrackingViewModel();
  active = false;
  minPauseShouldHave = 0;
  errorPause = false;
  unSeenMessagesNr = 0;
  transportDrivingModeSelected = false;
  transportBusModeSelected = false;
  language = this.userAuth.getLanguage();
  url = Url;
  originalStartTime = null;
  notificationsNr = null;
  isNotificationOpen = false;
  members = [];
  token= JSON.parse(localStorage.getItem("authUser")).access_token;
  getTimeFormated = Utilities.getTimeFormated
  membersOpen = false;
  autocompleteModel: {
    locations: Observable<any>;
    value: string;
    term: string;
    loading: boolean;
    data: any[];
    termChanged: Subject<string>;
  } = {
    locations: null,
    value: null,
    term: null,
    loading: false,
    data: [],
    termChanged: new Subject<string>(),
  };
  permissions = {
    READ_KNOWLEDGE_MANAGEMENT: this.userAuth.getAction(
      'READ_KNOWLEDGE_MANAGEMENT'
    ),
    READ_CHAT: this.userAuth.getAction(
      'READ_CHAT'
    ),
  };

  pusherClient = new Pusher(environment.pusherKey, { cluster: 'eu' });
  menuOptions=menuOptions;
  userPresencChannel= null;
  newVersionChannel= null;
  selectedSearchMenu= {text:'',item:{name:'locations'},default:true};
  projectList={show:false,searchValue:null,projects:[],loading:true,selectedProject:null};

  constructor(
    private router: Router,
    private translateService: TranslateService,
    private windowService: WindowService,
    private viewContainerRef: ViewContainerRef,
    private notificationService: NotificationService,
    private pagesEventService: PagesEventService,
    public layoutService: LayoutService,
    private chatService: ChatService,
    public confirmDialogService: ConfirmDialogService
  ) {}

  setOnSaving(value) {
    this.onSaving = value;
    this.pagesEventService.onSaving(value);
  }

  ngOnInit() {

    this.selectedSearchMenu.text=this.translateService.instant('Select module');

    this.pagesEventService.Title.subscribe((text) => {
      this.headerTitle = text;
    });

    this.pagesEventService.Breadcrumb.subscribe((items) => {
      this.breadcrumbs = items;
    });

    this.pagesEventService.OnSaving.subscribe((onSaving) => {
      this.onSaving = onSaving;
    });
    this.getAllEmployees();
    this.setOnSaving(true);
    this.getTimeLine();

    this.observeLocationChanged();
    this.getNotificationsNr();
    this.listenNewVersion();
    this.listenNotifications();
    this.listenTimeLineChanged();
    this.listenVersionPublished();
    this.listenGeneralProcessFinished();

    this.chatStatusUpdate();
    this.confirmDialogService.setViewContainerRef(this.viewContainerRef);
    this.isActive();
    this.listenForCountUnSennMessages();
    this.getCountUnSeenMessages()

    let item=localStorage.getItem('selectedSearchMenu');
    if(item){
      this.selectedSearchMenu=JSON.parse(item);
    }

    let selectedProject=localStorage.getItem('selectedProject');
    if(selectedProject){
      this.projectList.selectedProject=JSON.parse(selectedProject);
    }

    this.handelUserPresenc();
  }

  onUserInfoClick() {
    this.router.navigate(['/employee/personal']);
  }

  isActive() {
    if (this.userAuth.hireDate) {
      this.active =
        new Date(this.userAuth.hireDate).getTime() <= new Date().getTime();
    }
  }

  getTimeLine() {
    this.layoutService.getTime({}).subscribe((response) => {
      if (response.Status == 200 && response.TimeLine != null) {
        this.timeTrackingViewModel.set(
          response.TimeLine,
          response.Pauses,
          response.Entries || [],
          response.CurrentEntry || null
        );
        this.originalStartTime =
          response.CurrentEntry?.startTime ?? response.TimeLine.startTime;
        this.getProjectLines();
      }

      this.setOnSaving(false);
    });
  }
  listenNewVersion() {
    this.newVersionChannel = this.pusherClient.subscribe('app-channel');
    this.newVersionChannel.bind('new-version-available', (data: { version: string }) => {
      if (!data?.version) return;
      this.notificationService.showNewVersion(data.version);
    });
  }
  listenNotifications() {

    let channel = this.pusherClient.subscribe('notify-channel');
    channel.bind('notify-event', (data) => {
      this.getNotificationsNr(true);
    });
  }
  listenForCountUnSennMessages() {
    let channel = this.pusherClient.subscribe('chat-channel');
    channel.bind('chat-conversation-unread', (data) => {
      let item =  data.unreadCounts.find((item) => item.id == this.userAuth.id);
      if(item){
        this.unSeenMessagesNr = item.unread_count;
      }
    });
  }

  listenTimeLineChanged() {
    let channel = this.pusherClient.subscribe(`time-line.${this.userAuth.id}`);
    channel.bind('time-line-changed-event', (data) => {
      if(this.userAuth.id == data.id){
        this.getTimeLine();
      }
    });
  }


  listenGeneralProcessFinished() {
    let channel = this.pusherClient.subscribe('general-process-channel');
    channel.bind('general-process-finished', (data) => {
      this.pagesEventService.onGeneralProcessFinished(data);
    });
  }

  listenVersionPublished() {
    // let channel = this.pusherClient.subscribe('version-channel');
    // channel.bind('version-published-event', (data) => {});
  }

  chatStatusUpdate() {
    // let user = { id: this.userAuth.id, status: 'online' };
    // this.chatService.updateUserStatus(user).subscribe((result) => {});
    // document.onvisibilitychange = (e) => {
    //   if (document.visibilityState === 'hidden') {
    //     let user = { id: this.userAuth.id.toString(), status: 'away' };
    //     this.chatService.updateUserStatus(user).subscribe((result) => {});
    //   } else {
    //     let user = { id: this.userAuth.id, status: 'online' };
    //     this.chatService.updateUserStatus(user).subscribe((result) => {});
    //   }
    // };
  }


  getAllEmployees() {
    this.layoutService.getAllEmployees().subscribe((response) => {
      if (response.Status == 200) {
        this.members = response.Employees;
        let findIndex = this.members.findIndex(
          (res) => res.id == this.userAuth.id
        );
        this.members.splice(findIndex, 1);
      }
    });
  }
  openChat() {
    this.membersOpen = true;
  }
  getNotificationsNr(shouldShowAlert: boolean = false) {
    this.setOnSaving(true);
    this.layoutService.getNotificationsNr().subscribe((response) => {
      if (response.Status == 200) {
        if (shouldShowAlert && this.notificationsNr != response.NotificationsNr)
          this.notificationService.showSuccess('You have a new notification');

        this.notificationsNr = response.NotificationsNr;
      }

      this.setOnSaving(false);
    });
  }

  handleSearch(term: string) {
    this.autocompleteModel.term = term;
    this.autocompleteModel.data = [];
    this.autocompleteModel.loading = false;
    this.autocompleteModel.termChanged.next(term);
  }

  onKeyDown(event){
    if(event.key == 'Enter'){
      event.preventDefault();
      event.stopPropagation();
    }
  }

  observeLocationChanged() {

    this.autocompleteModel.locations =
      this.autocompleteModel.termChanged.pipe(
        filter((query: string) => {
          return !!query;
        }),
        tap(() => {
          (this.autocompleteModel.loading = true)}),
        debounceTime(300),
        //distinctUntilChanged(),
        switchMap((query) => {
          return this.searchBySelectedMenu(query);
        }),
        map((response: any) => response.data),
        tap(() => {
          (this.autocompleteModel.loading = false)
        })
      );


    this.autocompleteModel.locations.subscribe((response) => {
      console.log(response);


      if(this.selectedSearchMenu.item && ['locations','contracts','sitevisit','permits-shafts','permits-bottlenecks','permits-workHoles'].includes(this.selectedSearchMenu.item.name.toLowerCase()) ){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.fulllocation} | ${item.projectName}`,
          id: item.id,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'contacts'){
        this.autocompleteModel.data =[];
        for (const item of response) {
          if(!this.autocompleteModel.data.find(fndItem => fndItem.id == item.locationId))
            this.autocompleteModel.data.push({value: `${item.fulllocation} | ${item.projectName}`, id: item.locationId,projectId: item.projectId});
        }
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'shafts'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.fulllocation} | ${item.shaftProjectName}`,
          id: item.id,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'bottlenecks'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.fulllocation} | ${item.bottleneckProjectName}`,
          id: item.id,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'sleeves'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.fulllocation} ${item.spliceId ?? ''} | ${item.sleeveProjectName}`,
          id: item.id,
          shaftId: item.shaftId,
          spliceId: item.spliceId,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'locationsoto'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.fulllocation} | ${item.projectName}`,
          id: item.id,
          oto: item.oto,
          locationId: item.locationId,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-inhouse'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.fulllocation} | ${item.projectName}`,
          id: item.id,
          siteId: item.cp_sid,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-schachte'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.address} | ${item.assetIdSlot} | ${item.projectName}`,
          id: item.id,
          assetIdSlot: item.assetIdSlot,
          projectName: item.projectName,
          projectId: item.projectId,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-muffe'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.address} | ${item.spliceId} | ${item.projectName}`,
          id: item.id,
          spliceId: item.spliceId,
          projectName: item.projectName,
          projectId: item.projectId,
        }));

      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-oto'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.address}, ${item.location} ${item.plz} | ${item.projectName}`,
          id: item.id,
          oto: item.oto.replaceAll('.','_'),
          projectId: item.project_locations_id,
        }));
      }
      else if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-co'){
        this.autocompleteModel.data = response.map((item) => ({
          value: `${item.address} | ${item.cp_sid} | ${item.purchaseOrderId}`,
          id: item.id,
          cp_sid: item.cp_sid,
          purchaseOrderId: item.purchaseOrderId,
          projectId: item.project_locations_id,
        }));
      }
      else if(this.selectedSearchMenu.item && ['executiondesign','specification','drop','oto','inventory'].includes(this.selectedSearchMenu.item.name.toLowerCase())){

        this.autocompleteModel.data = response.map((item) => ({
          value:item.financeNr ? `${item.value} | ${item.financeNr} | ${item.projectName}` : `${item.value} | ${item.projectName}`,
          id: item.id,
          category: item.category,
          los: item.los,
          feeder: item.feeder,
          projectId: item.projectId,
        }));
      }

    });

  }

  searchBySelectedMenu(query): Observable<any>{

    if(this.selectedSearchMenu.item && ['locations','contracts','sitevisit'].includes(this.selectedSearchMenu.item.name.toLowerCase())){
      return this.layoutService.searchLocations(
        this.projectList.selectedProject?.id ?? -1,
        { skip: 0, take: 10 },
        'overviewLocations',
        {
          sort: [],
          search: null,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'fulllocation',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'siteId',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'mcpSid',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'lotNumber',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'gaiaAddress',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'locationKey',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'contractNr',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                ],
                logic: 'or',
              },
            ],
          },
        },
        []
      );
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'contacts'){
      return this.layoutService.searchLocationContacts(
        this.projectList.selectedProject?.id ?? -1,
        { skip: 0, take: 10 },
        {
          sort: [],
          search: query,
          filter: {
            filters: [],
          },
        }
      );
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'shafts'){
      return this.layoutService.searchShafts(
        this.projectList.selectedProject?.id ?? -1,
        { skip: 0, take: 10 },
        {
          sort: [],
          search: null,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'fulllocation',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'siteNr',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'manholeSiteId',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'assetIdSlot',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                ],
                logic: 'or',
              },
            ],
          },
        }
      );
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'bottlenecks'){
      return this.layoutService.searchBottlenecks(
        this.projectList.selectedProject?.id ?? -1,
        { skip: 0, take: 10 },
        {
          sort: [],
          search: null,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'fulllocation',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'bottleneckDesignation',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'siteNr',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                ],
                logic: 'or',
              },
            ],
          },
        },
      );
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'sleeves'){
      return this.layoutService.searchDropSleeves(this.projectList.selectedProject?.id ?? -1,
        { skip: 0, take: 10 },
        {
          sort: [],
          search: null,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'fulllocation',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'spliceId',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'assetIdSlot',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                ],
                logic: 'or',
              },
            ],
          },
        }
      );
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'locationsoto'){
      return this.layoutService.searchOtos(
        this.projectList.selectedProject?.id ?? -1,
        { skip: 0, take: 10 },
        {
          sort: [],
          search: null,
          excludeFilters:true,
          filter: {
            filters: [
              {
                filters: [
                  {
                    field: 'fulllocation',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'siteId',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'siteNr',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },

                  {
                    field: 'gaiaAddress',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'locationKey',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                  {
                    field: 'oto',
                    operator: 'contains',
                    value: query,
                    filter: 'text',
                  },
                ],
                logic: 'or',
              },
            ],
          },
        }
      );
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'permits-shafts'){

      return this.layoutService.searchPermits(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 },'permits',  {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'fulllocation',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'lotNumber',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'sidCode',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
            {
              filters: [
                {
                  field: 'permitType',
                  operator: 'eq',
                  value: 'shafts',
                  filter: 'text',
                },
              ],
              logic: 'and',
            },

          ],
        },
      })

    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'permits-bottlenecks'){

      return this.layoutService.searchPermits(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 },'permits',  {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'fulllocation',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'lotNumber',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'sidCode',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
            {
              filters: [
                {
                  field: 'permitType',
                  operator: 'eq',
                  value: 'bottlenecks',
                  filter: 'text',
                },
              ],
              logic: 'and',
            },

          ],
        },
      })
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'permits-workHoles'){

      return this.layoutService.searchPermits(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 },'permits',  {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'fulllocation',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'lotNumber',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'sidCode',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
            {
              filters: [
                {
                  field: 'permitType',
                  operator: 'eq',
                  value: 'workHoles',
                  filter: 'text',
                },
              ],
              logic: 'and',
            },

          ],
        },
      })
    }
    if(this.selectedSearchMenu.item && ['executiondesign','specification','drop','oto','inventory'].includes(this.selectedSearchMenu.item.name.toLowerCase())){
      return this.layoutService.searchExecutionDesign(query);
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-inhouse'){

      return this.layoutService.searchQCInhouse(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 }, {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'fulllocation',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'lotNumber',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'sidCode',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'response_workorder_id',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
          ],
        },
      })

    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-oto'){

      return this.layoutService.searchQCOto(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 }, {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'address',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'b_number',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'oto',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
          ],
        },
      })

    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-co'){

      return this.layoutService.searchQCCo(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 }, {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'address',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'cp_sid',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'assetID',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'purchaseOrderId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
          ],
        },
      })

    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-muffe'){

      return this.layoutService.searchQCMuffen(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 }, {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'address',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'assetIdSlot',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'spliceId',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
          ],
        },
      })

    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-schachte'){

      return this.layoutService.searchQCSchachte(this.projectList.selectedProject?.id ?? -1,{ skip: 0, take: 10 }, {
        sort: [],
        search: null,
        filter: {
          filters: [
            {
              filters: [
                {
                  field: 'address',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'siteNr',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
                {
                  field: 'assetIdSlot',
                  operator: 'contains',
                  value: query,
                  filter: 'text',
                },
              ],
              logic: 'or',
            },
          ],
        },
      })

    }

    return of([]);
  }

  openNewTab(event,dataItem){
    event.stopPropagation();
    this.locationAutoCompleteChanged(dataItem.value,true)
  }

  locationAutoCompleteChanged(value: any,newTab:boolean=false) {


    if(this.selectedSearchMenu.item && ['locations'].includes(this.selectedSearchMenu.item.name.toLowerCase())){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url= `/project/edit/${location.projectId}/overview/location/overviewLocations/${location.id}`;

        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);

      }
    }
    if(this.selectedSearchMenu.item && ['contracts'].includes(this.selectedSearchMenu.item.name.toLowerCase())){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url=  `/project/edit/${location.projectId}/overview/location/contracts/${location.id}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);

      }
    }
    if(this.selectedSearchMenu.item && ['sitevisit'].includes(this.selectedSearchMenu.item.name.toLowerCase())){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url=`/project/edit/${location.projectId}/overview/location/siteVisit/${location.id}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'contacts'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url= `/project/edit/${location.projectId}/overview/location/overviewLocations/${location.id}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'shafts'){
      let shaft = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );

      if (shaft) {
        let url= `/project/edit/${shaft.projectId}/overview/components/shaft/${shaft.id}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'sleeves'){
      let sleeve = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );

      if (sleeve) {
        if (sleeve.shaftId){

          let url= `/project/edit/${sleeve.projectId}/overview/drop/sleeve/${sleeve.shaftId}`;
          if(newTab)
            window.open(`${url};spliceId=${sleeve.spliceId};source=shafts`);
          else
            this.navigateTo(url,
              { spliceId: sleeve.spliceId, source: 'shafts' },
            );
        }
        else{
          let url=  `/project/edit/${sleeve.projectId}/overview/drop/sleeve/${sleeve.id}`;
          if(newTab)
            window.open(`${url};spliceId=${sleeve.spliceId};source=locations`);
          else
            this.navigateTo(url,
              { spliceId: sleeve.spliceId, source: 'locations' },
            );
        }

      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'locationsoto'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url= `/project/edit/${location.projectId}/overview/location/oto/${location.locationId};oto=${location.oto};referal=location`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-inhouse'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url=  `/project/edit/${location.projectId}/overview/quality-control/inhouse/${location.siteId}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-schachte'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url=  `/project/edit/${location.projectId}/overview/quality-control/schachte/${location.assetIdSlot}/${location.projectName}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-muffe'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location && location.spliceId) {
        let url=  `/project/edit/${location.projectId}/overview/quality-control/muffen/${location.spliceId.replaceAll(' ','')}/${location.projectName}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-oto'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {
        let url= `/project/edit/${location.projectId}/overview/quality-control/oto/${location.oto}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'qc-co'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {
        let url= `/project/edit/${location.projectId}/overview/quality-control/co/${location.cp_sid}/${location.purchaseOrderId}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'permits-shafts'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url= `/project/edit/${location.projectId}/overview/permits/shafts/${location.id}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'permits-bottlenecks'){
      let location = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (location) {

        let url= `/project/edit/${location.projectId}/overview/permits/bottlenecks/${location.id}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'executiondesign'){

      let item = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (item && item.los) {

        let url= `/project/edit/${item.projectId}/overview/executionDesign/los/${item.los}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
      if (item && item.feeder) {

        let url= `/project/edit/${item.projectId}/overview/executionDesign/feeder/${item.feeder}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'specification'){

      let item = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (item && item.los) {

        let url= `/project/edit/${item.projectId}/overview/specification/los/${item.los}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);

      }
      if (item && item.feeder) {

        let url= `/project/edit/${item.projectId}/overview/specification/feeder/${item.feeder}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'inventory'){

      let item = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (item && item.los) {

        let url= `/project/edit/${item.projectId}/overview/inventoryDetails/los/${item.los}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);

      }
      if (item && item.feeder) {

        let url= `/project/edit/${item.projectId}/overview/inventoryDetails/feeder/${item.feeder}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'drop'){

      let item = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (item && item.los) {

        let url= `/project/edit/${item.projectId}/overview/drop/${item.los}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);

      }
    }
    if(this.selectedSearchMenu.item && this.selectedSearchMenu.item.name.toLowerCase() == 'oto'){

      let item = this.autocompleteModel.data.find(
        (loc) => loc.value == value
      );
      if (item && item.los) {

        let url= `/project/edit/${item.projectId}/overview/oto/${item.los}`;
        if(newTab)
          window.open(url);
        else
          this.navigateTo(url);
      }
    }
  }

  navigateTo(url:string,extras:any={}){

    this.router.navigate(['/']);
    setTimeout(() => {
      this.router.navigate([url,extras]);
    }, 500);
  }

  onBtnStartPauseClick() {
    if (
      this.onSaving ||
      this.timeTrackingViewModel.isDayEnded ||
      !this.timeTrackingViewModel.timeLine.startTime
    )
      return;

    this.setOnSaving(true);
    var pause = this.timeTrackingViewModel.newPause();
    this.layoutService.startPauseTime(pause).subscribe((response) => {
      if (response.Status == 200) {
        this.timeTrackingViewModel.startPauseTime(response.TimeLine);
        this.setOnSaving(false);
      }
    });
  }

  onBtnResumeClick() {
    if (this.onSaving || this.timeTrackingViewModel.isDayEnded) return;

    this.setOnSaving(true);
    let pause = this.timeTrackingViewModel.resume();
    this.layoutService.resumePauseTime(pause).subscribe((response) => {
      if (response.Status == 200) {
        if (response.ResumePause === null) {
          this.timeTrackingViewModel.pauseTimeLines.pop();
        }
        this.setOnSaving(false);
      }
    });
  }

  logOut() {
    this.layoutService.logout().subscribe((response) => {
      if (response.Status == 200) {
        let recentLogins = localStorage.getItem('recent-logins');
        localStorage.clear();

        if(recentLogins)
          localStorage.setItem('recent-logins', recentLogins);

        this.permissionService.clearCache();
        this.router.navigate(['/login']);
      }
    });
  }

  onClickBreadCrumb(breadcrumb) {
    if (breadcrumb.routerLink) {
      if (typeof breadcrumb.extras === 'undefined') {
        this.router.navigate([breadcrumb.routerLink]);
      } else {
        this.router.navigate([breadcrumb.routerLink, breadcrumb.extras]);
      }

      if (typeof breadcrumb.onClick !== 'undefined') {
        breadcrumb.onClick();
      }
    }
  }

  onBtnStartTimeClick() {
    if (this.onSaving || this.timeTrackingViewModel.isDayEnded) return;
    if (this.timeTrackingViewModel.timeLine.isVactionFromEmployee) {
      this.notificationService.showInfo(
        this.translateService.instant(
          'You are on holiday but you can work today'
        )
      );
    }
    this.timeTrackingViewModel.timeLine.startTime = new Date(
      new Date().toDateString() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes() +
      ':00'
    );
    this.dialogs.startTime = true;
  }

  timePickerChanged(fromProject = false, line = null) {
    this.timeTrackingViewModel.calcSummary();
    this.showQuestions(this.timeTrackingViewModel.timeLine);
    if(!fromProject){
      this.minPauseShouldHave = this.timeTrackingViewModel.addPause();
      this.timeTrackingViewModel.calcSummary();
    }
    if(fromProject && line){
      this.timeTrackingViewModel.updateAdditionalDuration(line);
    }
    this.setErrorPauseMessage();
  }
  onSupervisorSundayToggle() {
    this.timeTrackingViewModel.reassignProjectLinesForCategory('sunday');
    this.timePickerChanged();
  }
  onSupervisorNightToggle() {
    this.timeTrackingViewModel.reassignProjectLinesForCategory('night');
    this.timePickerChanged();
  }
  timePickerPauseChanged(index, startTime = false) {
    if(startTime){
      this.timeTrackingViewModel.pauseTimeLines[index].endTime= new Date(this.timeTrackingViewModel.pauseTimeLines[index].startTime.setMinutes(this.timeTrackingViewModel.pauseTimeLines[index].startTime.getMinutes() + this.minPauseShouldHave));
    }
    setTimeout(() => {
      this.timeTrackingViewModel.calcSummary();
      this.setErrorPauseMessage();
    }, 0)
  }
  setErrorPauseMessage(){
    if (this.hasPauseOutsideSegment()) {
      this.errorPause = true;
      this.notificationService.showInfo(
        this.translateService.instant('Pause must be inside a segment')
      );
      return;
    }
    if (this.hasOverlappingPauses()) {
      this.errorPause = true;
      this.notificationService.showInfo(
        this.translateService.instant('Pauses must not overlap')
      );
      return;
    }
    if((this.timeTrackingViewModel.calSecPauses() < this.minPauseShouldHave * 60)){
      this.errorPause = true;
      this.notificationService.showInfo(this.translateService.instant('Die angegebene Pause erfüllt leider nicht die vorgeschriebene Mindestdauer von')+' '+ this.minPauseShouldHave+ ' ' + this.translateService.instant('Minuten'));
    }else if(this.timeTrackingViewModel.checkOneOfPauseMoreThan30Min()){
      this.errorPause = true;
      this.notificationService.showInfo(this.translateService.instant('One of the pauses must be more than 30 minutes'));
    }
    else{
      this.errorPause = false;
    }
  }

  private hasPauseOutsideSegment(): boolean {
    const segStart = this.timeTrackingViewModel.timeLine?.startTime;
    const segEnd = this.timeTrackingViewModel.timeLine?.endTime;
    if (!segStart || !segEnd) return false;
    return (this.timeTrackingViewModel.pauseTimeLines || []).some((p: any) => {
      if (!p?.startTime || !p?.endTime) return false;
      return !this.timeTrackingViewModel.pauseFullyInsideSegment(
        p,
        segStart,
        segEnd
      );
    });
  }

  private hasOverlappingPauses(): boolean {
    const pauses = (this.timeTrackingViewModel.pauseTimeLines || []).filter(
      (p: any) => p?.startTime && p?.endTime
    );
    for (let i = 0; i < pauses.length; i++) {
      for (let j = i + 1; j < pauses.length; j++) {
        const a1 = new Date(pauses[i].startTime).getTime();
        const a2 = new Date(pauses[i].endTime).getTime();
        const b1 = new Date(pauses[j].startTime).getTime();
        const b2 = new Date(pauses[j].endTime).getTime();
        if (isNaN(a1) || isNaN(a2) || isNaN(b1) || isNaN(b2)) continue;
        if (a1 < b2 && b1 < a2) return true;
      }
    }
    return false;
  }
  getAllProjects() {
    this.layoutService.getAllProjects().subscribe((response) => {
      if (response.Status == 200) {
        response.Projects.forEach((project) => {
          if (project?.type == 'internalProject') {
            if (this.language == 'de') {
              project.nrAndName = project.projectNr + ', ' + project.name;
            }
            if (this.language == 'en') {
              project.nrAndName = project.projectNr + ', ' + project.nameEn;
            }
            if (this.language == 'fr') {
              project.nrAndName = project.projectNr + ', ' + project.nameFr;
            }
            if (this.language == 'it') {
              project.nrAndName = project.projectNr + ', ' + project.nameIt;
            }
          } else {
            project.nrAndName = project.projectNr + ', ' + project.name;
          }
        });
        response.Projects.sort((a, b) => a.projectNr - b.projectNr);
        this.timeTrackingViewModel.collectionViewModel.projects =
          response.Projects;
      }
    });
  }

  onBtnEndTimeClick() {
    if (this.onSaving || this.timeTrackingViewModel.isDayEnded) return;
    const { timeLine } = this.timeTrackingViewModel;
    if (timeLine.isOnPause) {
      this.translateService.get('data saved').subscribe((text: string) => {
        this.notificationService.showError('Sie sind in der Pause');
      });

      return;
    }
    this.getAllProjects();
    this.timeTrackingViewModel.timeLine.endTime = new Date(
      new Date().toDateString() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes() +
      ':00'
    );
    this.timeTrackingViewModel.pauseTimeLines =
      this.timeTrackingViewModel.getCurrentSegmentPauses(
        this.timeTrackingViewModel.timeLine.startTime,
        this.timeTrackingViewModel.timeLine.endTime
      );
    this.timeTrackingViewModel.calcSummary();
    let addedPause = this.timeTrackingViewModel.addPause();
    this.minPauseShouldHave = addedPause
    this.setErrorPauseMessage();

    this.timeTrackingViewModel.calcSummary();
    let projects = this.timeTrackingViewModel.projects;

    if (projects) {
      let durations = [];
      this.timeTrackingViewModel.projectLines = [];
      this.timeTrackingViewModel.projects.forEach((project) => {
        durations.push(project.duration);
      });
      let projectDuration =
        this.timeTrackingViewModel.timeLine.durationWithAdditionalHours -
        durations.reduce((numbOne, numbTwo) => numbOne + numbTwo, 0);
      durations.forEach((duration, index) => {
        if (addedPause && index == 0 && projectDuration < 0) {
          this.timeTrackingViewModel.addProjectLine(
            duration - (addedPause * 60) > 0 ? duration - (addedPause * 60) : 0
          );
        } else {
          this.timeTrackingViewModel.addProjectLine(duration);
        }
      });

      if (addedPause && projectDuration < 0) {
        projectDuration += (addedPause * 3600);
      }

      if (projectDuration > 0) {
        this.timeTrackingViewModel.addProjectLine(projectDuration);
      }
    }
    this.showQuestions(timeLine);

    this.dialogs.endTime = true;
  }

  async endTime(fromTravelTime = false,fromTrasnportType = false ) {

    if (this.onSaving || this.timeTrackingViewModel.isDayEnded) return;
    let timeTracking: any = this.timeTrackingViewModel.getEndTime();
    timeTracking.timeLine.timeLineEntryId =
      this.timeTrackingViewModel.timeLine.currentEntry?.id ??
      this.timeTrackingViewModel.timeLine.timeLineEntryId ??
      null;
    try {
      let result = await this.getLongitudeAndLatitude();
      timeTracking.timeLine.latitude = result.latitude;
      timeTracking.timeLine.longitude = result.longitude;
    } catch (e) {
      this.dialogs.startTime = false;
      this.setOnSaving(false);
      this.timeTrackingViewModel.setToDefault();
      return this.notificationService.showErrorHide(
        'We need location permission in order to start the day'
      );
    }
    if(fromTravelTime){
      timeTracking.calcTravelTime = 0
    }
    if(fromTrasnportType){
      timeTracking.timeLine.checkShowTransportType = 0
    }
    this.setOnSaving(true);
    this.layoutService.endTime(timeTracking).subscribe((response) => {
      var d: any = new Date();
      var startDate = new Date(
        this.timeTrackingViewModel.timeLine.startTime
      ).toDateString();
      if (response.Status == 200) {
        this.dialogs.endTime = false;
        this.dialogs.transportTypeEnd = false
        if (response.endTime != null && typeof response.endTime.showTransportType != 'undefined') {
          this.setOnSaving(false);
          this.timeTrackingViewModel.timeLine = {...this.timeTrackingViewModel.timeLine, ...response.endTime}
          this.dialogs.transportTypeEnd = true
          this.timeTrackingViewModel.isDayEnded = false;
        }
        else if (response.endTime != null && typeof response.endTime.durationDifference != 'undefined') {
          this.getAllProjects();
          this.setOnSaving(false);
          this.timeTrackingViewModel.timeLine = {...this.timeTrackingViewModel.timeLine, ...response.endTime}
          this.dialogs.travelTimeEnd = true
          this.timeTrackingViewModel.isDayEnded = false;
        } else {
          if (response.endTime == 'timeLineDeleted') {
            this.timeTrackingViewModel.setToDefault();
          } else if (startDate != d.toDateString()) {
            this.timeTrackingViewModel.setToDefault();
          } else {
            this.getTimeLine();
          }
          this.dialogs.endTime = false;
          this.setOnSaving(false);
          if (this.router.url.startsWith('/time-management')) {
            this.pagesEventService.refershWeeklyReport();
          }
          this.dialogs.travelTimeEnd = false;
        }
      }
    });
  }

  getLongitudeAndLatitude(): Promise<{ longitude: number; latitude: number }> {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              longitude: position.coords.longitude,
              latitude: position.coords.latitude,
            });
          },
          (error) => {
            reject({});
          }
        );
      } else {
        reject({});
      }
    });
  }

  async startTime(fromTravelTime = false, fromTrasnportType = false) {
    if (this.onSaving || this.timeTrackingViewModel.isDayEnded) return;
    this.setOnSaving(true);
    let timeTrack = this.timeTrackingViewModel.get(fromTravelTime, fromTrasnportType);
    try {
      let result = await this.getLongitudeAndLatitude();
      timeTrack.latitude = result.latitude;
      timeTrack.longitude = result.longitude;
    } catch (e) {
      this.dialogs.startTime = false;
      this.setOnSaving(false);
      this.timeTrackingViewModel.setToDefault();
      return this.notificationService.showErrorHide(
        'We need location permission in order to start the day'
      );
    }
    this.timeTrackingViewModel.start();
    this.layoutService.startTime(timeTrack).subscribe({
      next: (response) => {
      if (response.Status == 200) {
        this.dialogs.startTime = false;
        this.dialogs.transportTypeStart = false
        if (typeof response.TimeLine.showTransportType != 'undefined') {
          this.setOnSaving(false);
          this.timeTrackingViewModel.timeLine = {...this.timeTrackingViewModel.timeLine, ...response.TimeLine}
          this.dialogs.transportTypeStart = true
        }else if (typeof response.TimeLine.durationDifference != 'undefined') {
          this.getAllProjects();
          this.setOnSaving(false);
          this.timeTrackingViewModel.timeLine = {...this.timeTrackingViewModel.timeLine, ...response.TimeLine}
          this.dialogs.travelTime = true

        } else {
          this.timeTrackingViewModel.timeLine.id = response.TimeLine.id;
          this.timeTrackingViewModel.timeLine.currentEntry =
            response.CurrentEntry ?? response.TimeLine;
          this.timeTrackingViewModel.timeLine.timeLineEntryId =
            response.CurrentEntry?.id ?? response.TimeLine?.id ?? null;
          this.originalStartTime =
            response.CurrentEntry?.startTime ?? response.TimeLine.startTime;
          this.timeTrackingViewModel.applyCurrentEntry(
            this.timeTrackingViewModel.timeLine.currentEntry
          );
          this.timeTrackingViewModel.timeLine.change = false;
          this.getTimeLine();
          if (this.router.url.startsWith('/time-management')) {
            this.pagesEventService.refershWeeklyReport();
          }
          this.setOnSaving(false);
          this.dialogs.travelTime = false;
        }
      }
      },
      error: (err) => {
        this.dialogs.startTime = false;
        this.dialogs.transportTypeStart = false;
        this.dialogs.travelTime = false;
        this.setOnSaving(false);
        this.timeTrackingViewModel.setToDefault();
        const code = err?.error?.error;
        const known: Record<string, string> = {
          SEGMENT_OVERLAP:       'segment_overlap',
          SEGMENT_INVALID_RANGE: 'segment_invalid_range',
          OPEN_SEGMENT_EXISTS:   'segment_open_exists',
          SEGMENT_GAP_TOO_SHORT: 'segment_gap_too_short',
        };
        const key = known[code] ?? 'unexpected_error';
        this.notificationService.showErrorHide(
          this.translateService.instant(key)
        );
        this.getTimeLine();
      },
    });
  }
  closeEndTime() {
    this.dialogs.endTime = false;
    this.timeTrackingViewModel.timeLine.isOnPause = false;
    this.timeTrackingViewModel.start();
    let index = this.timeTrackingViewModel.pauseTimeLines.findIndex(
      (timeLine) => timeLine.addedFromSystem == true
    );
    this.timeTrackingViewModel.timeLine.startTime = this.originalStartTime;
    if (index !== -1) {
      this.timeTrackingViewModel.pauseTimeLines.splice(index, 1);
    }
    this.timeTrackingViewModel.timeLine.endTime = null;
    this.timeTrackingViewModel.calSecPauses();
  }

  openNotificationsModal() {
    if (this.isNotificationOpen) return;

    this.isNotificationOpen = true;
    this.translateService.get('Notifications').subscribe((transleted) => {
      const windowRef = this.windowService.open({
        title: transleted,
        content: NotificationsComponent,
        width: 1200,
        appendTo: this.viewContainerRef,
        top: 100,
      });

      windowRef.result.subscribe((result) => {
        if (result instanceof WindowCloseResult)
          this.isNotificationOpen = false;
      });

      let notificationsComponent: NotificationsComponent = windowRef.content
        .instance as NotificationsComponent;

      notificationsComponent.formClosed.subscribe((formData) => {
        this.isNotificationOpen = false;
        windowRef.close();
      });
    });
  }

  deletePauseLine(pause, index) {
    if (pause.id) {
      this.layoutService
        .deletePause({
          id: pause.id,
          duration: pause.duration,
          timeLineId: this.timeTrackingViewModel.timeLine.id,
          empId: this.timeTrackingViewModel.timeLine.empId,
        })
        .subscribe();
    }
    this.timeTrackingViewModel.deletePauseLine(pause);
    this.timePickerPauseChanged(index);
  }
  showQuestions = (timeLine) => {
    const showNight = this.timeTrackingViewModel.showNightShiftQuestion(timeLine);
    const showSunday = this.timeTrackingViewModel.showSundayShiftQuestion(
      timeLine,
      timeLine.isVactionFromCalendar
    );
    this.timeTrackingViewModel.timeLine.showNightShiftQuestion = showNight;
    this.timeTrackingViewModel.timeLine.showSundayShiftQuestion = showSunday;
    // Clear a stale selection if the new time range no longer reaches into
    // night / Sunday hours, so a hidden question can't keep a checked value.
    if (!showNight) {
      this.timeTrackingViewModel.timeLine.includeNightDuration = false;
    }
    if (!showSunday) {
      this.timeTrackingViewModel.timeLine.includeSundayDuration = false;
    }
  };
  public filterSettings: DropDownFilterSettings = {
    caseSensitive: false,
    operator: 'contains',
  };
  onBtnNextClick() {
    const { startTime } = this.timeTrackingViewModel.timeLine;
    if (!startTime) return;
    let startTimeDb = Utilities.getFormatedDate(startTime);
    this.timeTrackingViewModel.timeLine.endTime = new Date(
      new Date().toDateString() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes() +
      ':00'
    );
    this.timeTrackingViewModel.calcSummary();
    this.timeTrackingViewModel.timeLine.endTime = null;
    let durations = [];
    this.timeTrackingViewModel.projects.forEach((project) => {
      durations.push(project.duration);
    });
    let duration =
      this.timeTrackingViewModel.timeLine.durationWithAdditionalHours -
      durations.reduce((numbOne, numbTwo) => numbOne + numbTwo, 0);
    if (duration > 0) {
      duration += duration % 60;
      this.timeTrackingViewModel.projects.push({
        date: startTime,
        empId: this.userAuth.id,
        duration,
      });
      this.layoutService
        .saveProjectLine({ duration, date: startTimeDb })
        .subscribe();
    }
  }
  getProjectLines = () => {
    const { startTime } = this.timeTrackingViewModel.timeLine;
    if (!startTime) return;
    let startTimeDb = Utilities.getFormatedDate(startTime);
    this.layoutService.getProjectLines(startTimeDb).subscribe((res) => {
      if (res.Status == 200) {
        this.timeTrackingViewModel.projects = res.projectLines;
      }
    });
  };
  openHelpPage() {
    let {url, routeName} = this.getCurrentUrl()
    if(this.userAuth.id == 1 || this.userAuth.id == 517){
      this.saveRoute(url,routeName.trim());
    }
    this.layoutService
      .getPageByLink(url)
      .subscribe((res: { Status: 200; page: Page }) => {
        if (res.page) {
          window.open(
            `libraries/${res.page.module.library.id}/modules/${res.page.module.id}/page/${res.page.id}?link=${url}`
          );
        } else {
          this.notificationService.showInfo(
            this.translateService.instant('Content for this page is still pending upload. Thank you for your patience') + '!'
          );
        }
      });
  }

  openMenu(){
    const element = document.querySelector('.k-link.k-menu-link') as any;
    if (element) {
      element.click();
      this.selectedSearchMenu.text=this.translateService.instant('Select module');
      this.selectedSearchMenu.default=true;
      this.selectedSearchMenu.item={name:'locations'};
    }
  }

  onSelectMenu(e) {

    this.autocompleteModel.value=null;
    this.autocompleteModel.loading = false;
    const selectedItem=e.item;
    if(e.item.items){
      this.selectedSearchMenu.text=this.translateService.instant('Select module');
      this.selectedSearchMenu.default=true;
      this.selectedSearchMenu.item={name:'locations'};
      localStorage.removeItem('selectedSearchMenu');
      return;
    }

    let items=this.menuOptions[0].items;
    const subItemSelected = items.flatMap(item => item.items || []).find(subItem => subItem.name === selectedItem.name);

    if(subItemSelected){
      const parent=items.find(item => item.items && item.items.find(subItem => subItem.name == selectedItem.name))
      this.selectedSearchMenu.text=`${parent.text} -> ${selectedItem.text}`;
      this.selectedSearchMenu.item=subItemSelected;
    }
    else{
      this.selectedSearchMenu.text=selectedItem.text;
      this.selectedSearchMenu.item=e.item;
    }

    this.selectedSearchMenu.default=false;
    console.log(this.selectedSearchMenu.item);
    localStorage.setItem('selectedSearchMenu',JSON.stringify(this.selectedSearchMenu));

  }

  saveRoute(link, title) {
    this.layoutService.saveRoute({link, title}).subscribe();
  }

  onProjectListButtonClick(){
    this.projectList.show=!this.projectList.show;

    if(this.projectList.projects.length == 0){
      this.layoutService.getAllProjects().subscribe((response) => {
        if (response.Status == 200) {
          this.projectList.projects=response.Projects;
          this.projectList.loading=false;
        }
      });
    }

  }

  onProjectListSearch(){

  }

  clearSelectedProject(){
    this.projectList.selectedProject=null;
    this.projectList.searchValue=null;
    localStorage.removeItem('selectedProject');
  }

  onProjectSelect(project){
    this.projectList.selectedProject=project;
    this.projectList.show=false;

    localStorage.setItem('selectedProject',JSON.stringify(project));
  }

  ngOnDestroy(): void {
    if (this.loadingDrivingIntervalId) {
      clearInterval(this.loadingDrivingIntervalId);
    }
    if (this.loadingBusIntervalId) {
      clearInterval(this.loadingBusIntervalId);
    }
    this.broadcastUserPresenc(this.router.url, 'out');
    if(this.userPresencChannel){
      this.userPresencChannel.unbind('user-presenc');
      this.pusherClient.unsubscribe('user-presenc');
    }

    if (this.newVersionChannel) {
      this.newVersionChannel.unbind('new-version-available');
      this.pusherClient.unsubscribe('app-channel');
    }
  }

  getCountUnSeenMessages() {
    this.chatService.getCountUnSeenMessages().subscribe(res => {
      if(res.countUnSeenMessages?.length){
        this.unSeenMessagesNr = res.countUnSeenMessages[0].unread_count;
      }
    });
  }

  private transportDrivingTimeoutId: any;
  transportDrivingSelected(){
    if(!this.transportDrivingModeSelected){
      clearTimeout(this.transportBusTimeoutId);
      this.transportBusTimeoutId = null;

      this.startDrivingLoadingBar();
      this.transportDrivingModeSelected = true;
      this.transportBusModeSelected = false;

      this.transportDrivingTimeoutId = setTimeout(() => {
        if(this.transportDrivingModeSelected){
          this.timeTrackingViewModel.timeLine.transportTypeMode = {id: 'driving', name: 'Car'};
          if(this.dialogs.transportTypeStart){
            this.startTime(false, true);
          }
          else if(this.dialogs.transportTypeEnd){
            this.endTime(false, true);
          }
          this.transportDrivingModeSelected = false;
        }
      }, 3000);
    }
  }

  private transportBusTimeoutId: any;

  transportBusSelected(){
    if(!this.transportBusModeSelected){
      clearTimeout(this.transportDrivingTimeoutId);
      this.transportDrivingTimeoutId = null;

      this.startBusLoadingBar();
      this.transportBusModeSelected = true;
      this.transportDrivingModeSelected = false;
      this.transportBusTimeoutId = setTimeout(() => {
        if(this.transportBusModeSelected){
          this.timeTrackingViewModel.timeLine.transportTypeMode = {id: 'transit', name: 'Bus/Train'};
          if(this.dialogs.transportTypeStart){
            this.startTime(false, true);
          }
          else if(this.dialogs.transportTypeEnd){
            this.endTime(false, true);
          }
          this.transportBusModeSelected = false;
        }
      }, 3000);
    }
  }

  loadingDrivingWidth = 0;
  private loadingDrivingIntervalId: any;
  startDrivingLoadingBar() {
    clearInterval(this.loadingBusIntervalId);
    this.loadingBusIntervalId = null;
    this.loadingBusWidth = 0;

    this.loadingDrivingWidth = 0;
    this.loadingDrivingIntervalId = setInterval(() => {
      if (this.loadingDrivingWidth < 100) {
        this.loadingDrivingWidth += 1;
      } else {
        this.loadingDrivingWidth = 0;
        clearInterval(this.loadingDrivingIntervalId);
      }
    }, 30);
  }

  loadingBusWidth = 0;
  private loadingBusIntervalId: any;
  startBusLoadingBar() {
    clearInterval(this.loadingDrivingIntervalId);
    this.loadingDrivingIntervalId = null;
    this.loadingDrivingWidth = 0;

    this.loadingBusWidth = 0;
    this.loadingBusIntervalId = setInterval(() => {
      if (this.loadingBusWidth < 100) {
        this.loadingBusWidth += 1;
      } else {
        this.loadingBusWidth = 0;
        clearInterval(this.loadingBusIntervalId);
      }
    }, 30);
  }

  findLocation(typeCalc) {
    let firstDestination = null;
    let secondDestination = this.timeTrackingViewModel.timeLine.constructionLocation;

    if(typeCalc == "office"){
      // anotherOffice
      firstDestination = this.timeTrackingViewModel.timeLine.office;
    }
    else if(typeCalc == "home"){
      // myHome
      firstDestination = this.timeTrackingViewModel.timeLine.home;
    }
    let googleMapsUrl;
    if(this.dialogs.travelTime){
      googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(firstDestination)}&destination=${encodeURIComponent(secondDestination)}`;
    }else{
      googleMapsUrl = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(secondDestination)}&destination=${encodeURIComponent(firstDestination)}`;
    }
    window.open(googleMapsUrl);
  }
  broadcastUserPresenc(url:string, type: 'in'|'out'): void {
    let {url: u} = this.getCurrentUrl();
    if(u == 'project/edit/:id/overview/location/contracts/:id' || u == 'project/edit/:id/overview/location/siteVisit/:id'){
      fetch(this.url.apiUrl + '/userPresenc/broadcast', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${this.token}`
        },
        body:  JSON.stringify({ url, type}),
        keepalive: true
      });
    }

  }


  listenForUserPresenc() {
    this.userPresencChannel = this.pusherClient.subscribe(`user-presenc.${this.userAuth.id}`);
    this.userPresencChannel.bind(`user-presenc.${this.userAuth.id}`, (data) => {
      const isSameUrl = this.router.url == data.data.url;
      if (isSameUrl) {
        const i = this.usersOnThisPage.findIndex(
          (d) => data.data.user.id === d.user.id && this.router.url == data.data.url
        );
        if (data.data.type === 'in') {
          if (i !== -1) {
            this.usersOnThisPage[i].tabs =this.usersOnThisPage[i].tabs  +1 ;
          } else {
            this.usersOnThisPage.push(data.data);
          }
        } else {
          if (i !== -1) {
            if (this.usersOnThisPage[i].tabs == 1) {
              this.usersOnThisPage.splice(i, 1);
            } else {
              this.usersOnThisPage[i].tabs = this.usersOnThisPage[i].tabs -1 ;
            }
          }
        }
      }
    });
  }

  getUserPresenc(url) {
    let {url:u} = this.getCurrentUrl()
    if(u == 'project/edit/:id/overview/location/contracts/:id' || u == 'project/edit/:id/overview/location/siteVisit/:id'){
      this.layoutService.getUserPresenc(url).subscribe(res => {
        this.usersOnThisPage = res.userPresenc;
      })
    }
  }

  handelUserPresenc() {
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationStart){
        this.broadcastUserPresenc(this.router.url, 'out');
      }
      if(event instanceof NavigationEnd){
        this.broadcastUserPresenc(event.urlAfterRedirects, 'in');
        this.getUserPresenc(event.urlAfterRedirects);
      }
    });

    this.broadcastUserPresenc(this.router.url, 'in');

    this.listenForUserPresenc();
    this.getUserPresenc(this.router.url);
    window.addEventListener("beforeunload", (e) => {
      this.broadcastUserPresenc(this.router.url, 'out');
    });
  }

  getCurrentUrl() {
    let routeName = '';
    let url= this.router.url
      .split('/')
      .splice(1, this.router.url.split('/').length - 1)
      .map((item) => {
        if (!isNaN(parseInt(item))) {
          return ':id';
        } else {
          routeName += ' ' +Utilities.capitalizeFirstLetter(item);
          return item;
        }
      })
      .join('/');

    return {url, routeName}
  }
  showAnotherTabOpen() {
    return !!this.usersOnThisPage.find((i) => this.router.url == i.url && i.user.id == this.userAuth.id && i.tabs>=2)
  }
  getNightProjects() {
    return this.timeTrackingViewModel.getNightProjects();
  }
  getDayProjects() {
    return this.timeTrackingViewModel.getDayProjects();
  }
  getSundayProjects() {
    return this.timeTrackingViewModel.getSundayProjects();
  }
}
